export default "__VITE_ASSET__DfbYJemB__"